// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__cOQNQ","Rotatebg":"Footer_Rotatebg__wYY8U","footer__icons":"Footer_footer__icons__Abg8j"};